<template>
  <section class="partner-world-section">
    <div class="partner-world-shell">
      <div class="partner-world-bg" :style="backgroundStyle"></div>

      <div class="container partner-world-content">
        <div class="partner-heading" v-reveal>
          <span class="partner-copy-tag">{{ tagText }}</span>
          <div class="partner-heading-en">GLOBAL PARTNERS</div>
          <h2>{{ titleText }}</h2>
          <p>{{ subtitleText }}</p>
        </div>

        <div class="partner-logo-wall" v-reveal>
          <div
            v-for="(logo, index) in logos"
            :key="logo.src"
            class="partner-logo-card"
            :style="{ transitionDelay: index * 0.03 + 's' }"
          >
            <img :src="logo.src" :alt="logo.alt" />
          </div>
        </div>

        <div class="partner-map-side" v-reveal>
          <div class="partner-map-wrap">
            <img class="partner-map" src="/tu/tu2.png" :alt="titleText" />
            <div class="partner-glow"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PartnerWorldMap",
  data() {
    const files = [
      "1704763694695576.jpg",
      "1704763720998106.jpg",
      "1704763735820857.jpg",
      "1704763826666021.jpg",
      "1704763848855225.jpg",
      "1704763871123733.jpg",
      "1704763920145043.jpg",
      "1704763939959059.jpg",
      "1704763969360227.jpg",
      "1704763982227012.jpg",
      "1734934889538647.png",
      "1734934942701278.png",
      "1734935053915194.png",
      "1734935248716799.png",
      "1734936382871496.png",
      "1734936574774629.png",
      "1736470705780321.png",
      "1736471196276340.png",
      "1737430268134869.jpg",
      "1737437133266295.jpg"
    ];

    return {
      logos: files.map((file, index) => ({
        src: `/tu/${file}`,
        alt: `partner-logo-${index + 1}`
      }))
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.92)), url('/tu/bg5.jpg')"
      };
    },
    tagText() {
      return this.locale === "zh-CN" ? "GLOBAL PARTNERS" : "GLOBAL PARTNERS";
    },
    titleText() {
      return this.locale === "zh-CN" ? "合作客户与全球布局" : "Clients and Global Reach";
    },
    subtitleText() {
      return this.locale === "zh-CN"
        ? "江苏宏邦变压器有限公司持续服务电力、能源、工业与海外项目客户，形成稳定的合作网络与全球化业务布局。"
        : "Jiangsu Hongbang Transformer Co., Ltd. serves clients across power, energy, industry and overseas projects with a steadily expanding global network.";
    }
  }
};
</script>

<style scoped>
.partner-world-section {
  position: relative;
  overflow: hidden;
  background: #ffffff;
}

.partner-world-shell {
  position: relative;
  min-height: 980px;
}

.partner-world-bg {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.partner-world-content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(420px, 620px) minmax(520px, 1fr);
  grid-template-areas:
    "heading heading"
    "logos map";
  gap: 56px;
  align-items: start;
  min-height: 980px;
  padding-top: 84px;
  padding-bottom: 120px;
}

.partner-heading {
  grid-area: heading;
  max-width: 520px;
}

.partner-heading-en {
  margin: 18px 0 8px;
  font-size: clamp(48px, 6vw, 80px);
  font-weight: 800;
  line-height: 0.95;
  letter-spacing: 0.01em;
  background: linear-gradient(90deg, #1252a7 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.partner-logo-wall {
  grid-area: logos;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  align-self: center;
}

.partner-logo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  padding: 18px;
  border: 1px solid rgba(222, 227, 235, 0.92);
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 18px 40px rgba(20, 47, 88, 0.06);
  backdrop-filter: blur(4px);
  transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
}

.partner-logo-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(10, 61, 124, 0.02));
  pointer-events: none;
}

.partner-logo-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: saturate(0.96);
  transition: transform 0.35s ease, filter 0.35s ease;
}

.partner-logo-card:hover {
  transform: translateY(-8px);
  border-color: rgba(19, 79, 153, 0.14);
  box-shadow: 0 24px 52px rgba(20, 47, 88, 0.12);
}

.partner-logo-card:hover img {
  transform: scale(1.04);
  filter: saturate(1.06);
}

.partner-map-side {
  grid-area: map;
  position: relative;
  min-height: 650px;
}

.partner-copy-tag {
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.16em;
  background: linear-gradient(135deg, #134f99, #1a6fcb 58%, #4f64b8);
  box-shadow: 0 16px 32px rgba(127, 38, 94, 0.18);
}

.partner-heading h2 {
  margin: 18px 0 18px;
  color: #1f2d3c;
  font-size: clamp(34px, 2.6vw, 46px);
  line-height: 1.16;
}

.partner-heading p {
  margin: 0;
  color: #717b89;
  font-size: 16px;
  line-height: 1.9;
}

.partner-map-wrap {
  position: absolute;
  right: 6%;
  bottom: 2%;
  width: min(980px, 100%);
}

.partner-map {
  position: relative;
  z-index: 1;
  width: 100%;
  filter: drop-shadow(0 28px 40px rgba(120, 136, 156, 0.16));
  animation: mapFloat 8s ease-in-out infinite;
}

.partner-glow {
  position: absolute;
  right: 10%;
  bottom: 12%;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(17, 79, 153, 0.09), transparent 70%);
  filter: blur(8px);
}

@keyframes mapFloat {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@media (max-width: 1300px) {
  .partner-world-content {
    grid-template-columns: 1fr;
    grid-template-areas:
      "heading"
      "logos"
      "map";
  }

  .partner-map-side {
    min-height: 560px;
  }

  .partner-map-wrap {
    position: relative;
    right: 0;
    bottom: 0;
    width: 100%;
  }
}

@media (max-width: 900px) {
  .partner-world-shell {
    min-height: auto;
  }

  .partner-world-content {
    min-height: auto;
    gap: 34px;
    padding-top: 72px;
    padding-bottom: 72px;
  }

  .partner-logo-wall {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .partner-logo-card {
    padding: 16px;
  }

  .partner-map-side {
    min-height: auto;
  }

  .partner-heading-en {
    font-size: 44px;
  }

  .partner-heading h2 {
    font-size: 30px;
  }

  .partner-heading p {
    font-size: 14px;
    line-height: 1.8;
  }
}

@media (max-width: 520px) {
  .partner-world-content {
    gap: 28px;
    padding-top: 52px;
    padding-bottom: 52px;
  }

  .partner-copy-tag {
    padding: 8px 12px;
    font-size: 11px;
    letter-spacing: 0.12em;
  }

  .partner-heading-en {
    font-size: 38px;
  }

  .partner-heading h2 {
    font-size: 26px;
  }

  .partner-logo-wall {
    gap: 10px;
  }

  .partner-logo-card {
    padding: 12px;
  }

  .partner-glow {
    display: none;
  }
}
</style>
